import gsap from 'gsap'

document.addEventListener('DOMContentLoaded', ()=> {
  const accordions = document.querySelectorAll('.accordion')

  const duration = .5

  const closeAccordion = (content) => {
    gsap.to(content, {
      height: 0,
      duration,
      ease: 'none'
    })
  }

  const openAccordion = (content) => {
    gsap.to(content, {
      height: 'auto',
      duration,
      ease: 'none'
    })
  }

  accordions?.forEach(accordion => {
    const accordionHead = accordion.querySelector('.accordion__head')
    const accordionContent = accordion.querySelector('.accordion__content')
    const videos = accordionContent.querySelectorAll('video')

    if(videos) {
      videos.forEach(video => {
        if(video.closest('.video__wrapper')) return
        video.addEventListener('click', () => {
          if(video.paused) {
            video.play()
            return
          }
          video.pause()
        })

      })
    }

    accordionHead?.addEventListener('click', ()=> {
      if(accordion.classList.contains('accordion--open')) {
        accordion.classList.remove('accordion--open')
        closeAccordion(accordionContent)
      } else {
        accordion.classList.add('accordion--open')
        openAccordion(accordionContent)
      }
    })
  })
})